import React, { useState } from 'react'
import 'antd/dist/antd.css';
import { DatePicker, Space, Typography } from 'antd';
const RangeDate = (props) => {
  const { onChange, name, value, title } = props
  const { RangePicker } = DatePicker;
  return (
    <Space direction="vertical" style={{ display: 'flex' }}>
      <Typography.Title level={5} style={{ textAlign: "left", margin: 0, fontSize: 16, fontWeight: 500 }}>
        {title}
      </Typography.Title>
      <RangePicker format='MMM, DD YY' placeholder={["From", "To"]}
        onChange={(d) => onChange({ [name]: d })}
        value={value ? value : null} />
    </Space>
  )
}

export default RangeDate